import Cookies from "js-cookie";
import { decode } from "base-64";

export const isLogin = () => {
    const token = Cookies.get('accessToken')
    return token
};

export const getVehicleType = () => {
    const vehicletype = decode(Cookies.get('vehicletype'))
    return vehicletype
};

export const is3w = () => {
    return getVehicleType() == "3W"
};

export const is2w = () => {
    return getVehicleType() == "2W"
};